import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);

        this.events = {
            input: {
                select: 'change'
            }
        }
    }

    init() {
        this.bindResize = this.resize.bind(this);
        window.addEventListener('resize',this.bindResize);

        this.$contents = this.$('content');

        this.resize();

    }

    change(e) {

        for (let i = 0; i < this.$contents.length; i++) {
            const content = this.$contents[i];

            if(content.classList.contains('is-active')) {
                content.classList.remove('is-active');
            }
            if(content.getAttribute('id') === e.curTarget.value) {
                content.classList.add('is-active');
            }
        }
    }

    resize() {
        let height = 0;

        for (let i = 0; i < this.$contents.length; i++) {
            const content = this.$contents[i];

            if(content.getBoundingClientRect().height > height) {
                height = content.getBoundingClientRect().height;
            }
        }

        this.$('wrapper')[0].style.height = `${height}px`;
    }

    destroy() {
        window.removeEventListener('resize',this.bindMousemove);

    }
}
